import { useMediaQuery } from './media';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

export function prefersReducedMotion(): boolean {
  return reducedMotion.matches;
}

export function useReducedMotion(): boolean {
  return useMediaQuery(reducedMotion);
}

export type Easing = (k: number) => number;

export const easeInOutCubic: Easing = (k) => (k < 0.5 ? 4 * k * k * k : 1 - (-2 * k + 2) ** 3 / 2);
export const easeOutCubic: Easing = (k) => 1 - (1 - k) ** 3;

export class Tween {
  value: number;
  private from: number;
  private to: number;
  private start = 0;
  private duration = 0;
  private readonly ease: Easing;

  constructor(value: number, ease: Easing) {
    this.value = value;
    this.from = value;
    this.to = value;
    this.ease = ease;
  }

  retarget(to: number, durationMs: number): boolean {
    if (to === this.to) return false;
    this.from = this.value;
    this.to = to;
    this.start = performance.now();
    this.duration = prefersReducedMotion() ? 0 : durationMs;
    return true;
  }

  step(): boolean {
    if (this.value === this.to) return false;
    const k = this.duration === 0 ? 1 : Math.min(1, (performance.now() - this.start) / this.duration);
    this.value = k === 1 ? this.to : this.from + (this.to - this.from) * this.ease(k);
    return this.value !== this.to;
  }
}
